import React, { Component } from 'react';
import Loading from '../Components/Loading.js'
import { getDocumentLabels } from '../Api/DocumentLabels.js'
import { getFileExtensions, getFileMimeTypes, getFileMaxSizeMb } from '../Api/Namezzz'
import { getTranslation } from '../Utilities/GetTranslation.js'
import { postPersonAttachments } from '../Api/UserActions.js';

declare var globalSns;

class NamezzzUploads extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.upload = this.upload.bind(this);
    }

    componentWillMount() {
        this.setState({
            uploadingFiles: []
        });
        this.loadData();
    }

    loadData() {        
        getDocumentLabels(globalSns.languageId, (data) => {
            this.setState({
                documentLabels: data
            });
        });
        getFileExtensions((data) => {
            this.setState({
                fileExtensions: data
            });
        });
        getFileMimeTypes((data) => {
            this.setState({
                fileMimeTypes: data
            });
        });
        getFileMaxSizeMb((data) => {
            this.setState({
                maxSizeMb: data
            });
        });
    }

    saveData(fileUpload) {
        postPersonAttachments(fileUpload.file, fileUpload.seqtemp, this.props.jobId, globalSns.languageId, (data) => {
            // reload attachments
            this.props.onFileUploadsSaved();
            var i = this.state.uploadingFiles.indexOf(fileUpload.fileName);
            if(i > -1){
                this.state.uploadingFiles.splice(i, 1);
            }
            this.showFileLoading();
        });
    }

    showFileLoading(){
        this.fileLoading.style.display = ((this.state.uploadingFiles.length === 0) ? "none":"block");
    }

    upload() {
        var file = this.el;
        var errDoclabel = this.errDoclabel;
        var errType = this.errType;
        var errSize = this.errSize;

        if (file == null || file.files.length !== 1) {
            return false;
        }

        errDoclabel.style.display = "none";
        errType.style.display = "none";
        errSize.style.display = "none";

        if (this.props.jobId < 0 ) {
            if (this.props.onNoJobIdSelected != null) {
                this.props.onNoJobIdSelected(); // Event for parent control
            }
            file.value = null;
            return false;
        }

        var fileSeqTemp = this.doclabel.value;
        var fileName = file.files[0].name;
        var fileExtension = fileName.split(".").pop().toLowerCase();
        var fileMimeType = file.files[0].type.toLowerCase();
        var fileSizeMb = file.files[0].size / 1024 / 1024;
        var errorOccured = false;

        if (fileSeqTemp === "0") {
            errDoclabel.style.display = "block";
            file.value = null;
            errorOccured = true;
        }

        if (this.state.fileExtensions.indexOf(fileExtension) < 0 ||
            this.state.fileMimeTypes.indexOf(fileMimeType) < 0)
        {
            errType.style.display = "block";
            file.value = null;
            errorOccured = true;
        }

        if(this.state.maxSizeMb <= fileSizeMb) {
            errSize.style.display = "block";
            file.value = null;
            errorOccured = true;
        }

        if(errorOccured) {
            return false;
        }

        this.state.uploadingFiles.push(fileName);
        this.saveData({
            file: file,
            seqtemp: fileSeqTemp,
            fileName: fileName
        });
        this.showFileLoading();

        this.doclabel.value = "0";

        return true;
    }

    render() {

        if (this.state.documentLabels == null || this.state.fileExtensions == null ||
            this.state.fileMimeTypes == null || this.state.maxSizeMb == null) {
            return (
                <Loading/>
            );
        }

        return (
            <div>
                <div className="tr">
                    <div className="FieldLabel td">
                        <label htmlFor="upload1">{getTranslation("sns.webparts.uploads.attachments")}
                        </label>
                    </div>
                    <div className="EditingFormValueCell td">
                        <div className="namezzzAttachments">
                            <div>
                                <div className="js-namezzzattachments-upload">
                                    {
                                        (this.state.documentLabels) ?
                                            <div>
                                                <select className="DropDownField form-control" ref={el => this.doclabel = el}>
                                                    <option value="0">{getTranslation("sns.formcontrols.namezzzattachments.choosedoclabel")}</option>
                                                    {
                                                        this.state.documentLabels.map((doclabel) =>
                                                            <option key={doclabel.templateId} value={doclabel.templateId}>{doclabel.value}</option>
                                                        )
                                                    }
                                                </select>
                                                &nbsp;
                                            </div> :
                                            ""
                                    }
                                    <div className="uploader-upload">
                                        <input id="upload1" ref={el => this.el = el} type="file" onChange={this.upload} />
                                    </div>
                                    <div className="file-loading" ref={el => this.fileLoading = el} style={{display: "none"}}>
                                        <img src="/Search_Selection/assets/images/ripple.gif" alt="Loading" />
                                        <span>{getTranslation("sns.formcontrols.namezzzattachments.uploading")}</span>
                                    </div>
                                    <div className="js-namezzzattachments-error js-namezzzattachments-label-error" ref={el => this.errDoclabel = el} style={{display: "none"}}>
                                        <span className="EditingFormErrorLabel">{getTranslation("sns.formcontrols.namezzzattachments.filelabelerror")}</span>
                                    </div>
                                    <div className="js-namezzzattachments-error js-namezzzattachments-type-error" ref={el => this.errType = el} style={{display: "none"}}>
                                        <span className="EditingFormErrorLabel">{getTranslation("sns.formcontrols.namezzzattachments.filetypeerror")}</span>
                                    </div>
                                    <div className="js-namezzzattachments-error js-namezzzattachments-size-error" ref={el => this.errSize = el} style={{display: "none"}}>
                                        <span className="EditingFormErrorLabel">{getTranslation("sns.formcontrols.namezzzattachments.filesizeerror")}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NamezzzUploads;


// WEBPACK FOOTER //
// ./src/Fields/NamezzzUploads.js